import React from "react";
import "./GoalsFL.css";
import Resources from "../../../Resources/Resources";
import {Col, Container, Modal, Row} from "react-bootstrap";
import {APP_SECTION} from "../../../scripts/constants";
import {mygaSession} from "../../../scripts/myga-session";
import {saveApplication} from "../../../scripts/sync-manager";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {PageManager} from "../../../scripts/page-manager";
import {
  isPaymentScenarioValid,
  isReplacementOrCD,
  reconcileParties,
  reconcilePaymentsForProducts
} from "../../../scripts/validation";
import Question from "../../../components/Questions/Question";
import {NassauLog} from "../../../scripts/myga-utils";
import {MM_PRODUCT_DTO} from "../../../scripts/myga-model";

class GoalsFL extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      goals: {...mygaSession.getCurrentAppGoals()},
      finances: {...mygaSession.getCurrentAppFinances()},
      funds: {...mygaSession.getCurrentAppFunds()},
      general: {...mygaSession.getCurrentAppGeneral()},
      errorMessage:'',
      showEarlyFundsModal: false
    };
  
  }

  saveApplication = async () => {
    
    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.goals,this.state.goals);
    await saveApplication(APP_SECTION.goals);
  
    mygaSession.setCurrentAppSectionData(APP_SECTION.finances,this.state.finances);
    await saveApplication(APP_SECTION.finances);
  
    mygaSession.setCurrentAppSectionData(APP_SECTION.funds,this.state.funds);
    await saveApplication(APP_SECTION.funds)
    
    mygaSession.setCurrentAppSectionData(APP_SECTION.general,this.state.general);
    await saveApplication(APP_SECTION.general)
    
    // 2021.09.08.ADivelbiss - Check to see if payments should be cleared.
    // Do this after regular data are saved
    const nextProductDTOs = reconcilePaymentsForProducts();
    if (nextProductDTOs) {
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs);
      await saveApplication(APP_SECTION.products)
    }
    
    // 2021.11.11.ADivelbiss - need to reconcile parties at this point if the
    // user comes back to this page and make different selections.
    const parties = reconcileParties();
    if (parties) {
      mygaSession.setCurrentAppParties(parties);
      await saveApplication(APP_SECTION.parties);
      // 2022.05.19.ADivelbiss - currently assume all parties applied to all selected products.
      const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.parties]=parties);
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
      await saveApplication(APP_SECTION.products);
    }
    
  };
  
  handleChange = (section) => (field) => (e) => {
    let data = {...this.state[section]};
    data[field] = e.target && e.target.value !== undefined ? e.target.value : e;
    NassauLog(`${section}:${field} => '${data[field]}'`);
    let nextState = {errorMessage:''};
    nextState[section] = data;
    this.setState(nextState);
  };
  
  // 2022.04.07.ADivelbiss - This "wrapper" was needed to prevent the QuestionCurrent
  // from suffering from an infinite render loop.  Using this.handleChange('funds') directly
  // in the replacementFL question below caused the dependency of one of the
  // effects in QuestionCurrency.jsx to be updated every render itself causing a render.
  // Needed to tie the function to an instance of this class.
  handleChangeFunds = (field) => (e) => {this.handleChange('funds')(field)(e);};
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Goals_ErrorMissingInformation
      });
      return false;
    }
    
    return true;
  };

  render() {
    
    return (
        <AppContentWrapper
            onBackPressed={this.saveApplication}
            onNextPressed={this.saveApplication}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>

          <form className={'needs-validation'}
                         ref={(form) => {
                           this.pageForm = form;
                         }}>
            <Container className={'pb-3'}>
              <Container>
                <Question
                    containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                    data={this.state.funds}
                    question={PageManager.getQuestionByName('replacementFL')}
                    onChange={this.handleChangeFunds}/>
    
                <Question
                    containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                    question={PageManager.getQuestionByName('penaltyFreeAccessFL')}
                    data={this.state.funds}
                    onChange={this.handleChange('funds')}
                />
    
                <Question
                    containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                    question={PageManager.getQuestionByName('hasReverseMortgageFL')}
                    data={this.state.funds}
                    onChange={this.handleChange('funds')}
                />
                <Question
                    containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                    question={PageManager.getQuestionByName('trustEstablishmentFL')}
                    data={this.state.general}
                    onChange={this.handleChange('general')}
                />
                <Question
                    containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                    question={PageManager.getQuestionByName('additionalInfoFL')}
                    data={this.state.funds}
                    onChange={this.handleChange('funds')}
                />
    
                <Question
                    containerClass={'pb-2 mt-4 pl-4 pl-md-5'}
                    questionClass={'text-xs-left text-sm-center'}
                    question={PageManager.getQuestionByName('sourceOfFundsForPurchaseFL')}
                    data={this.state.finances}
                    onChange={this.handleChange('finances')}
                />
  
                <Question
                    containerClass={'pb-2 mt-4 pl-4 pl-md-5'}
                    questionClass={'text-xs-left text-sm-center'}
                    question={PageManager.getQuestionByName('sourceOfFundsNonQualOrIRA')}
                    data={this.state.finances}
                    onChange={this.handleChange('finances')}
                />
                
              </Container>
            </Container>
          </form>

          <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showCallForHelpMessage}
              onHide={()=>{
                this.setState({
                  showCallForHelpMessage: false
                })
              }}
          >

            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  {Resources.Strings.Goals_ErrorCallForHelp}
                </Col>
              </Row>

            </Modal.Body>

          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showEarlyFundsModal}
            onHide={()=>{
              this.setState({
                showEarlyFundsModal: false
              })
            }}
          >
            <Modal.Header closeButton/>
            <Modal.Body>
              {Resources.Strings.Goals_InfoEarlyAccess}
            </Modal.Body>
          </Modal>

        </AppContentWrapper>
    );
    
  }
}

export default GoalsFL;